import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { DevicesStore, InstallationFeaturesStore, RichDevice } from '@store';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  NumberValue,
  PropertiesValue,
} from '@vi-iot/client/index';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-system-v2-cascade',
  templateUrl: './system-v2-cascade.component.html',
  styleUrls: ['./system-v2-cascade.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemV2CascadeComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  devicesOfV2Cascade$: Observable<RichDevice[]>;

  private readonly multiDevicesCascadeTopLimit = 3;

  constructor(
    protected devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.devicesOfV2Cascade$ = this.devicesStore.getTopDevicesOfV2Cascade(
      this.multiDevicesCascadeTopLimit
    );
  }

  trackBy(_index: number, device: RichDevice): string {
    return device.boilerSerial;
  }

  protected getCascadeMemberId(
    deviceId: string
  ): Observable<Feature<PropertiesValue<NumberValue>, never>> {
    return this.installationFeaturesStore.selectInstallationDeviceFeature<
      PropertiesValue<NumberValue>,
      never
    >(FeatureNames.cascadeMemberId, deviceId);
  }
}
